import * as React from 'react'
import { Image, Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'

import useI18n from '@i18n/useI18n'

import theme from '@theme/Theme'

export const BUTTON_HEIGHT = 80

interface Props {
  count: number
  onClick: () => void
}

const DraftButton = ({ count, onClick }: Props) => {
  const i18n = useI18n()
  return (
    <ButtonContainer activeOpacity={0.9} onPress={onClick}>
      <LeftContainer>
        <Title>{i18n.t('components.draftButton.title', { count })}</Title>
      </LeftContainer>
      <Icon name="arrow" size={24} color={theme.colors.primary} />
      <BackgroundPicture source={require('@assets/images/documents.png')} resizeMode="contain" />
    </ButtonContainer>
  )
}

export default DraftButton

const ButtonContainer = styled(TouchableOpacity)`
  background-color: ${(props) => props.theme.colors.primaryLight};
  border-radius: 8px;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  height: ${BUTTON_HEIGHT}px;
  overflow: hidden;
`

const LeftContainer = styled(View)`
  flex: 1;
  margin-right: 16px;
`

const Title = styled(Text)`
  ${(props) => props.theme.fonts.Subheadline};
  margin-bottom: 4px;
`

const BackgroundPicture = styled(Image)`
  position: absolute;
  z-index: -1;
  top: -20px;
  right: 5px;
  width: 100px;
  height: 115px;
`
